// Español

export default {
    'About': '',
    'Company': 'Empresa',
    'Contact': 'Contacto',
    'Email Address': 'Dirección de correo electrónico*',
    'First Name': 'Nombre',
    'Get In Touch': 'Empezar',
    'Manage Cookies': '',
    'Media Kit': '',
    'Newsroom': '',
    'Password': '',
    'Privacy Policy': '',
    'Related Case Studies': '',
    'Related Resources': 'Recursos relacionados',
    'See Case Study': 'Enviar',
    'Sign up': 'Registrarse',
    'Submit': 'Enviar',
    'The Goal': '',
    'View All': 'Ver todo',
    'You are missing one or more requred fields': ''
};
